module.exports = __webpack_public_path__ + "static/media/icon-cross.bab1b4f2.svg";